import React from 'react';
import './Galerie.scss';

import logoPatte from '../../assets/img/logo-patte-removebg-preview.png';
import GalerieImportImg from './GalerieImportImg';

function Galerie() {
    return (
        <main className="galerie-container">
            <div className="galerie-background">
                <div className="galerie-background__container-title">
                    <p className="galerie-background__title">La Truffe à 4 Pattes</p>
                    <img className="galerie-background__logo" src={logoPatte} alt="Logo" />
                </div>
            </div>
            <section className="galerie__content">
                <h1 className='galerie__main-title'>Galerie</h1>
                <GalerieImportImg />
                <div className="galerie-more">
                    <a className='galerie-more__link'
                        href="https://www.facebook.com/latruffea4pattes/photos?locale=fr_FR" target="_blank" rel="noopener noreferrer">
                        Plus de photos ? Vous pouvez consulter ma page facebook.
                    </a>
                    <a className='galerie-more__link-cassandra'
                        href="https://www.facebook.com/groups/1784739578621121" target="_blank" rel="noopener noreferrer">
                    </a>
                </div>
            </section>
        </main>
    );
}

export default Galerie;
